import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";
var _templateObject;
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import defaultTheme from '../../theme';
var Grid = styled.div.withConfig({
  displayName: "Grid",
  componentId: "sc-1oyfl5s-0"
})(["margin-right:auto;margin-left:auto;max-width:100%;padding-right:", "rem;padding-left:", "rem;", ";", ";"], function (p) {
  return p.theme.grid.outerMargin / 2;
}, function (p) {
  return p.theme.grid.outerMargin / 2;
}, function (p) {
  return p.fluid && "\n      padding-right: " + p.theme.grid.outerMargin + "rem;\n      padding-left: " + p.theme.grid.outerMargin + "rem;\n  ";
}, function (p) {
  return !p.fluid && css(["", ";"], ['md', 'lg'].map(function (viewport) {
    return p.theme.media[viewport](_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n        width: ", "rem;\n      "])), p.theme.grid.container[viewport]);
  }));
});
Grid.defaultProps = {
  theme: defaultTheme,
  fluid: false
};
Grid.propTypes = {
  /**
   * Create a responsive fixed width Grid or a
   * full width Grid, spanning the entire width
   * of your viewport. */
  fluid: PropTypes.bool
};

/** @component */
export default Grid;